<div class="list-filters-content">
  <mat-form-field class="filter-item search-input">
    <mat-label>Student</mat-label>
    <fa-icon matPrefix [icon]="['fas', 'magnifying-glass']"></fa-icon>
    <input
      data-test-id="SEARCH_FILTER_INPUT"
      matInput
      (keyup.enter)="filters.searchInput = $event.target.value; filtersUpdated.emit(filters)" />
  </mat-form-field>
  <app-autocomplete
    label="Grade"
    placeholder="Grade"
    (selectionChange)="onFiltersUpdated('grade', $event)"
    [options]="studentGrades"
    class="filter-item-small"
  />
  <app-autocomplete
    label="Complied"
    placeholder="Complied"
    (selectionChange)="onFiltersUpdated('complied',$event)"
    [options]="complianceOptions"
    class="filter-item-medium"
  />
  <app-autocomplete
    label="Reactions"
    placeholder="Reactions"
    (selectionChange)="onFiltersUpdated('reactionId',$event)"
    [options]="reactionOptions"
    class="filter-item"
  />
  <app-autocomplete
    label="Issued By"
    placeholder="Issued By"
    (selectionChange)="onFiltersUpdated('userId',$event)"
    [options]="userOptions"
    class="filter-item"
  />
  <app-autocomplete
    label="Homeroom"
    placeholder="Homeroom"
    (selectionChange)="onFiltersUpdated('homeroom',$event)"
    [options]="homerooms"
    class="filter-item-small"
  />
  <mat-form-field class="filter-item-medium">
    <mat-label>Start Date</mat-label>
    <input
      matInput
      [matDatepicker]="startDatePicker"
      type="text"
      [value]="startDate"
      (dateChange)="onStartDateUpdated($event)" />
    <mat-datepicker-toggle
      matSuffix
      [for]="startDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #startDatePicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="filter-item-medium">
    <mat-label>End Date</mat-label>
    <input
      matInput
      [matDatepicker]="endDatePicker"
      type="text"
      [value]="endDate"
      (dateChange)="onEndDateUpdated($event)" />
    <mat-datepicker-toggle
      matSuffix
      [for]="endDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #endDatePicker></mat-datepicker>
  </mat-form-field>
</div>
